module.exports = __webpack_public_path__ + "static/media/ag.35dcc943.jpg";